import { useContext, useEffect } from 'react'

import { SiteContext } from '../../Global/SiteContext'
import { useDigifiSearchCore } from '../../DigifiSearch/Hooks/Core/useDigifiSearchCore'

const useUpdateProductInformation = articleNumber => {
   const { setProductInformation } = useContext(SiteContext)
   const { getProductByItemNo } = useDigifiSearchCore()

   useEffect(() => {
      if (!articleNumber) {
         setProductInformation(null)
         return
      }
      ;(async () => {
         const productData = await getProductByItemNo({
            itemNo: articleNumber,
         })

         if (!productData) {
            setProductInformation(null)
            return
         }
         // Remove isOnSale computation/prop when its available in productData
         setProductInformation(productData)
      })()
      // eslint-disable-next-line react-hooks/exhaustive-deps
   }, [articleNumber])
}

export default useUpdateProductInformation
